import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white mt-16">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              {/* Simple text logo for footer */}
              <div className="flex flex-col leading-tight">
                <div className="flex items-center gap-1.5">
                  <span className="text-2xl md:text-3xl font-extrabold text-white tracking-tight">
                    HVAC
                  </span>
                  <span className="text-xl md:text-2xl font-bold text-blue-400">
                    Best
                  </span>
                </div>
                <span className="text-xs font-semibold text-gray-400 tracking-widest uppercase mt-0.5">
                  SUPPLY
                </span>
              </div>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Your trusted partner for high-quality refrigerants. We provide fast shipping and competitive prices on all HVAC supplies.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-white transition">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Our Products</h4>
            <ul className="space-y-2 text-sm">
              <li className="text-gray-400">R22 Refrigerant</li>
              <li className="text-gray-400">R410A Refrigerant</li>
              <li className="text-gray-400">R134A Refrigerant</li>
              <li className="text-gray-400">R454B Refrigerant</li>
              <li className="text-gray-400">R404A Refrigerant</li>
              <li className="text-gray-400">R448A Refrigerant</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin size={18} className="text-blue-400 mt-1 flex-shrink-0" />
                <span className="text-gray-400">
                  Downey, California
                </span>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={18} className="text-blue-400 mt-1 flex-shrink-0" />
                <a href="mailto:hvacbestsupply@gmail.com" className="text-gray-400 hover:text-white transition">
                  hvacbestsupply@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Phone size={18} className="text-blue-400 mt-1 flex-shrink-0" />
                <a href="tel:+15624161615" className="text-gray-400 hover:text-white transition">
                  +1 562-416-1615
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} HVAC Best Supply. All rights reserved.</p>
          <p className="mt-2">100% Virgin Refrigerants | Fast Shipping | Competitive Prices</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;